import React, { useRef, useEffect } from 'react';
import * as echarts from 'echarts';

const WebECharts = ({ option, height = 300, width = '100%', style = {} }) => {
  const chartRef = useRef(null);

  useEffect(() => {
    // 初始化图表
    let chart;
    if (chartRef.current) {
      chart = echarts.init(chartRef.current);
      chart.setOption(option);
    }

    // 处理窗口大小变化
    const handleResize = () => {
      chart && chart.resize();
    };
    window.addEventListener('resize', handleResize);

    // 清理函数
    return () => {
      chart && chart.dispose();
      window.removeEventListener('resize', handleResize);
    };
  }, [option, chartRef]);

  return (
    <div
      ref={chartRef}
      style={{
        width: width,
        height: height,
        ...style,
      }}
    />
  );
};

export default WebECharts; 